import React from 'react';
import { useMemberApp } from '../AppProvider';
import { IconClose } from './Icons';

export default function LifetimeBanner() {
  const { lifetimeOpen, setLifetimeOpen, setUpgradeOpen, setPricingFocus } = useMemberApp();
  if (!lifetimeOpen) return null;

  const claim = () => {
    setLifetimeOpen(false);
    setPricingFocus('lifetime');
    setUpgradeOpen(true);
    try {
      sessionStorage.setItem('byonco:lifetime:seen', '1');
    } catch {
      /* ignore */
    }
  };

  const dismiss = () => {
    setLifetimeOpen(false);
    try {
      sessionStorage.setItem('byonco:lifetime:seen', '1');
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="by-life-pop" role="dialog" aria-modal="true" aria-labelledby="by-life-title">
      <div className="by-life-card">
        <button type="button" className="by-icon-btn" style={{ position: 'absolute', top: 14, right: 14 }} onClick={dismiss} aria-label="Close">
          <IconClose />
        </button>
        <span className="by-life-sash">Limited lifetime offer</span>
        <h2 id="by-life-title">Keep Vani for life. $999 once.</h2>
        <p>
          Monthly is $19.99. Yearly is $14.99/month. Families who know this is a years-long road
          lock the companion in with one payment. No renewals.
        </p>
        <div className="by-life-prices">
          <span><s>$2,399</s></span>
          <strong>$999</strong>
          <small>lifetime access</small>
        </div>
        <button type="button" className="by-btn by-btn-dark" style={{ width: '100%' }} onClick={claim}>
          Claim lifetime offer
        </button>
        <button
          type="button"
          className="by-btn by-btn-ghost"
          style={{ width: '100%', marginTop: 8 }}
          onClick={() => {
            setLifetimeOpen(false);
            setPricingFocus('yearly');
            setUpgradeOpen(true);
            try {
              sessionStorage.setItem('byonco:lifetime:seen', '1');
            } catch {
              /* ignore */
            }
          }}
        >
          Compare monthly and yearly
        </button>
      </div>
    </div>
  );
}
